import { LogLevel } from "@azure/msal-browser";

const b2cPolicies = {
  names: {
    //signUpSignIn: "B2C_1_smbfglobal_signin_signup",
    signUpSignIn: "B2C_1_smbf_signin_signup",
  },
  authorities: {
    signUpSignIn: {
      //authority: "https://smbfglobal.b2clogin.com/smbfglobal.onmicrosoft.com/B2C_1_smbfglobal_signin_signup",
      authority: "https://smbfglobal.b2clogin.com/smbfglobal.onmicrosoft.com/B2C_1_smbf_signin_signup",
    },
  },
  authorityDomain: "smbfglobal.b2clogin.com",
};

export const msalConfig = {
  auth: {
    clientId: "f123e474-3b6e-411b-b2a5-61c2452c8036",
    authority: b2cPolicies.authorities.signUpSignIn.authority,
    knownAuthorities: [b2cPolicies.authorityDomain],
    //redirectUri: window.location.origin, // redirect to dashboard after login
    //  redirectUri: "http://localhost:3000", // redirect to dashboard after login
    redirectUri: "https://www.connect.smbf.global",
    postLogoutRedirectUri: "/", // redirect to home after logout
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: true,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level: LogLevel, message: any, containsPii: any) => {
        if (containsPii) return;
        if (level === LogLevel.Error) console.error(message);
        if (level === LogLevel.Info) console.info(message);
        if (level === LogLevel.Verbose) console.debug(message);
        if (level === LogLevel.Warning) console.warn(message);
      },
    },
  },
};

export const loginRequest = {
  scopes: ["openid", "profile","email", "https://smbfglobal.onmicrosoft.com/user-api/user.read"],
};
